<template>
    <div class="badge_select_container" @blur="open = false">
        <div class="badge_select" :class="{ open: open, active: selectedOptions.length }" @click="toggle()">
            <span class="badge_title">{{ def }}</span>
            <div class="badge_info_containers">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="selectedOptions.length" @click.prevent="() => {$emit('clear'); open = !open;}">
                    <g clip-path="url(#clip0_7053_117492)">
                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#6C757D"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_7053_117492">
                        <rect width="24" height="24" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_7132_87957)">
                        <path d="M7.41 9.08984L12 13.6698L16.59 9.08984L18 10.4998L12 16.4998L6 10.4998L7.41 9.08984Z" fill="#356EEF"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_7132_87957">
                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
        <div class="badge_select_content" v-if="open">
            <div v-for="(option, i) in options" :key="i"
                class="badge_select_value"
            >
                <label @click.prevent="() => { selected = option; open = false; $emit('modelValue', option); }">
                    <input class="form_radio" type="checkbox" :checked="selectedOptions.includes(option)">
                    <span>{{ option }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedOptions: {
      type: Array,
      required: false,
    },
    def: {
      type: String,
      required: false,
      default: null,
    },
    value: {
        type: String,
        required: false,
        default: null,
    },
    drop: {
        type: String,
        required: false,
        default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
        selected: null,
        open: false,
    };
  },
  mounted() {
    if (this.selected !== this.def) {
    //  this.$emit("update:modelValue", this.selected); 
    }
  },
    watch: {
        'drop': {
            handler: function(newValue) {
                if (newValue !== this.def) {
                    this.open = false
                }
            }
        },
    },

    methods: {
        toggle(){
            this.open = !this.open

            this.$emit("droped", this.def);
        }
    }
};
</script>

<style scoped>
.badge_select_container {
    min-width: 0;
    position: relative;
}
.badge_select {
    width: 100%;
    display: flex;
    padding: 8px 12px;
    align-items: center;
    justify-content: center;
    gap: 12px;
    border-radius: 4px;
    border: 1px solid var(--system-gray-03, #CED4DA);
    cursor: pointer;
    color: rgba(0, 0, 0, 0.90);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.badge_select.active {
    background: #EFF4FE;
}
.badge_select_content {
    position: absolute;
    min-width: 100%;
    border-radius: 4px;
    border: 1px solid #CCC;
    background: #FFF;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    z-index: 1;
    max-height: 300px;
    overflow: auto;
}
.badge_select_content .badge_select_value label {
    display: flex;
    gap: 10px;
    padding: 10px 10px;
    cursor: pointer;
}
.badge_select_content .badge_select_value label:hover {
    background: #EFF4FE;
}

.form_radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}
input[type='checkbox'] {
    outline: 2px solid #356EEF;
    outline-style: auto;
}
input[type='checkbox']:checked {
    outline: 2px solid #356EEF;
    outline-style: auto;
}
input[type='checkbox']:not(:checked) {
    outline: 2px solid #356EEF;
    outline-style: auto;
}
.badge_info_containers {
    display: flex;
    align-items: center;
    gap: 5px;
}

.badge_title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>